import './index.less';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import FormUI from '@/componentsUI/Form';
import { feedback } from '@/utils/feedback';
import InputWalletDropdown from '../../compoents/InputWalletDropdown';
import { useTranslationPlus } from '@/Core/i18n/useTranslationPlus';
import { useInitWithdrawCryptoMu, useWalletAll, useWalletWithdrawCrypto } from '@/store/walletStore';
import FromItemPlus from '@/components/FormItemPlus/FromItemPlus';
import SelectNetwork from '@/components/WalletComp/SelectNetwork';
import { AmountDivisorConversion, AmountMultiplierConversion, dealAmount0Fiexd, dealAmount9Valid } from '@/Core/utils/currencyDealCenter';
import InputWithdrawAmount from '@/components/WalletComp/InputWithdrawAmount';
import { IFInitWalletRsp } from '@/api/apiRsp/IFWalletRsp';
import ButtonUI from '@/componentsUI/Button';
import useDialogManager from '@/utils/useDialogManager';
import { isUSDT_ERC20, isUSDT_TRC20 } from '@/Core/features/verification';
import { sys } from '@/Core/utils/system';
import InputUI from '@/componentsUI/Input';
import { FromValidate } from '@/Core/utils';
import useDialog from '@/utils/useDialog';
import { useCurrency } from '@/hooks/useCurrency';
import WithdrawTaxNotice from '../components/WithdrawTaxNotice';
import { useUserInfo } from '@/store/userInfo';
import { runWithdrawalOfficialAppPrompt } from '@/features/install/withdrawalOfficialAppPrompt';

const Crypto = () => {
  const prefixCls = 'withdraw-crypto';
  const { t } = useTranslationPlus('Wallet');
  const { t: tCommon } = useTranslationPlus();
  const currency = useCurrency();
  const [form] = FormUI.useForm();
  const [values, setValues] = useState<any>(); //form对象值
  const { data } = useWalletAll();
  const { data: userInfo } = useUserInfo();
  const { crypto: cryptoWallet } = data || {}
  const [currentWallet, setCurrentWallet] = useState<IFInitWalletRsp>();
  const { data: networkDatas, trigger: triggerGetNetwork, isMutating } = useInitWithdrawCryptoMu();
  const { trigger: triggerWithdraw, isMutating: withdrawMutating } = useWalletWithdrawCrypto(); //提交加密提现
  const { openGoogleTowFactor } = useDialogManager();
  const [feeAmount, setFeeAmount] = useState('0');
  const addressRef = useRef(null);
  const { close, closeAll } = useDialog();

  const validate = FromValidate(form);
  //获取虚拟币网络节点
  const getNetwork = useCallback(
    (index) => {
      const item = cryptoWallet[index];
      if (!item) {
        return;
      }
      triggerGetNetwork({
        currencyType: item?.currencyType,
        device: sys.device,
      }).catch((e) => {
        feedback.error(tCommon(e?.code));
      });
    },
    [cryptoWallet]
  );
  //获取手续费
  const getFee = useCallback(() => {
    const withdrawAmount = form.getFieldValue('withdrawAmount');
    const withdrawNetwork = form.getFieldValue('withdrawNetwork');
    const { adminFee = 0, withdrawalCommission = 0 } = withdrawNetwork || {};
    const fee = (
      Number(withdrawAmount) * (Number(withdrawalCommission) / 100) +
      AmountDivisorConversion(adminFee, {
        currencyType: currentWallet.currencyType,
      })
    ).toFixed(2);
    setFeeAmount(fee);
  }, [currentWallet]);

  const onChangeCurrency = useCallback(
    (index) => {
      const item = cryptoWallet[index];
      if (!item) {
        return;
      }
      setCurrentWallet(item);
    },
    [cryptoWallet]
  );

  //点击提现
  const onClickWithdraw = () => {
    addressRef.current = true;
    validate()
      .then((v) => {
        const params = {
          currencyType: v?.walletType, //无选中，则取默认值
          money: AmountMultiplierConversion(v?.withdrawAmount, {
            currencyType: v?.walletType,
          }),
          address: v?.withdrawAddress, //无选中，则取默认值
          networkType: v?.withdrawNetwork?.networkType,
        };
        return runWithdrawalOfficialAppPrompt({
          stage: "before_submit",
          userId: userInfo?.userId,
          onContinue: () =>
            triggerWithdraw(params)
              .then((rsp) => {
                if (rsp?.googleAuth) {
                  openGoogleTowFactor({
                    trigger: triggerWithdraw,
                    params: params,
                    complete: () => {
                      closeAll();
                    },
                  });
                } else {
                  closeAll();
                }
              })
              .catch((e) => {
                if (e?.code == 'ERROR_60028') {
                  if (e?.data?.withdrawAmount == 0) {
                    feedback.error(
                      tCommon('WITHDRAW_NEED_BET', {
                        betCode: dealAmount9Valid(e?.data?.betTarget, {
                          currencyType: e?.data?.currency,
                        }),
                        currency,
                      })
                    );
                  } else {
                    feedback.error(
                      tCommon('WITHDRAW_ALREADY_BET', {
                        alreadyCode: dealAmount9Valid(e?.data?.withdrawAmount, {
                          currencyType: e?.data?.currency,
                        }),
                        currency,
                      })
                    );
                  }
                } else {
                  feedback.error(tCommon(e?.code));
                }
              }),
        });
      })
      .finally(() => {
        console.log('--------------');
        addressRef.current = false;
      });
  };

  useEffect(() => {
    if (cryptoWallet) {
      form.setFieldValue('walletType', cryptoWallet?.[0]?.currencyType);
      getNetwork(0);
      onChangeCurrency(0);
    }
  }, [cryptoWallet]);

  useEffect(() => {
    if (networkDatas && networkDatas.length) {
      form.setFieldValue('withdrawNetwork', { ...networkDatas[0] });
    }
  }, [networkDatas]);

  const validatorAddress = (value, cb) => {
    const v = form?.getFieldValue('withdrawNetwork');
    if (!addressRef.current && !value) {
      return;
    }
    if (v) {
      let flag = false;
      if (v?.networkType == 'TRC20') {
        flag = isUSDT_TRC20(value);
      } else if (v?.networkType == 'ERC20') {
        flag = isUSDT_ERC20(value);
      }
      if (!flag) {
        return cb(t('WrongAddress', { networkAddress: v?.networkType }));
      }
    }
  };
  const validatorAmount = (value, cb) => {
    const network = form?.getFieldValue('withdrawNetwork');
    if (!addressRef.current && !value) {
      return;
    }
    const amount = AmountMultiplierConversion(value, {
      currencyType: currentWallet.currencyType,
    });
    if (!amount || amount > currentWallet?.balance || amount < Number(network?.singleMinimumCoin) || amount > Number(network?.singleMaximumCoin)) {
      return cb(t('Wrong Amount'));
    }
  };
  const selectedWithdrawNetwork =
    values?.withdrawNetwork || form.getFieldValue('withdrawNetwork');

  return (
    <div className={`${prefixCls}`}>
      <FormUI
        disabled={withdrawMutating || isMutating}
        className={`${prefixCls}-form`}
        form={form}
        layout={'vertical'}
        autoComplete={'off'}
        onValuesChange={(v, v_) => {
          setValues(v_);
        }}
      >
        <FromItemPlus field={'walletType'} label={t('WithdrawCurrencyTitle')}>
          <InputWalletDropdown
            options={cryptoWallet}
            onChange={(currencyType, v) => {
              onChangeCurrency(v?._index);
              getNetwork(v?._index);
            }}
          />
        </FromItemPlus>
        <FromItemPlus field={'withdrawNetwork'} label={t('SelectNetworkTitle')}>
          <SelectNetwork
            options={networkDatas}
            onChange={() => {
              form.setFieldValue('withdrawAddress', '');
              form.setFieldValue('withdrawAmount', '');
              form.clearFields('withdrawAddress');
              form.clearFields('withdrawAmount');
              setFeeAmount('0');
            }}
          />
        </FromItemPlus>
        <FromItemPlus
          field={'withdrawAddress'}
          label={t('WithdrawAddressTitle')}
          required={true}
          rules={[{ validator: validatorAddress }]}
          onBlur={() => {
            validate(['withdrawAddress']);
          }}
        >
          <InputUI placeholder={t('WalletDes', { networkAddress: values?.withdrawNetwork?.networkType })} maxLength={34} />
        </FromItemPlus>
        <FromItemPlus
          field={'withdrawAmount'}
          label={
            <div className={`${prefixCls}-title`}>
              <span> {t('WithdrawAmountTitle')} </span>
              <span className="r">
                {t(`WithdrawMinAmountDesc`)}
                <span>
                  {' '}
                  {dealAmount0Fiexd(values?.withdrawNetwork?.singleMinimumCoin, {
                    currencyType: currentWallet?.currencyType ?? "",
                  })}
                </span>
              </span>
            </div>
          }
          required={true}
          rules={[{ validator: validatorAmount }]}
          onBlur={() => {
            validate(['withdrawAmount']);
          }}
        >
          <InputWithdrawAmount
            balance={dealAmount9Valid(currentWallet?.balance, {
              currencyType: currentWallet?.currencyType,
            })}
            min={dealAmount9Valid(values?.withdrawNetwork?.singleMinimumCoin, {
              currencyType: currentWallet?.currencyType,
            })}
            max={dealAmount9Valid(values?.withdrawNetwork?.singleMaximumCoin, {
              currencyType: currentWallet?.currencyType,
            })}
            onChange={() => {
              getFee(); //汇率
            }}
          />
        </FromItemPlus>
      </FormUI>
      <div className={`${prefixCls}-fee`}>
        <WithdrawTaxNotice
          rate={selectedWithdrawNetwork?.withdrawalCommission}
          amount={feeAmount}
        />
      </div>
      <ButtonUI className={`${prefixCls}-btn`} type="primary" disabled={isMutating || withdrawMutating} onClick={onClickWithdraw}>
        {t('Withdraw')}
      </ButtonUI>
    </div>
  );
};

export default Crypto;
